import { createFileRoute } from "@tanstack/react-router";
import Profile from "@/pages/Profile";
import { MainLayout } from "@/components/layout/MainLayout";

const title = "My profile | Statlign";
const description = "Your Statlign credits, unlocked picks, invite link, AI Access and preferences in one place.";

export const Route = createFileRoute("/profile")({
  head: () => ({
    meta: [
      { title },
      { name: "description", content: description },
      { property: "og:title", content: title },
      { property: "og:description", content: description },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: ProfileRoute,
});

function ProfileRoute() {
  return (
    <MainLayout>
      <Profile />
    </MainLayout>
  );
}
